export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-01.4f8cfb45.png";